<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <!-- Page Wrapper -->
    <div class="customer-view-wrapper" v-if="invoice.currency">
      <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
          <h5 class="mb-2">
            <div
              v-if="prev_page === 'invoice-details'"
              @click="router.go(-1)"
              class="d-flex align-center justify-content-start"
              style="color: #28084b; cursor: pointer"
            >
              <i class="feather feather-arrow-left me-1"></i>
              <span class="fs-6">Back</span>
            </div>
          </h5>
          <div class="content-invoice-header">
            <div class="mt-2 mt-lg-0">
              <router-link :to="{ name: 'register' }" class="btn btn-primary"
                >Create free account</router-link
              >
            </div>
            <div class="list-btn" style="position: relative">
              <ul class="filter-list">
                <li>
                  <a
                    @click="openModal(invoice, 'download')"
                    class="btn-filters w-auto"
                    ><i class="fa fa-download" aria-hidden="true"></i
                  ></a>
                </li>
                <li>
                  <a @click="copyInvoiceLink" class="btn-filters w-auto px-2"
                    ><i class="fa fa-clone me-2" aria-hidden="true"></i>Copy
                    link</a
                  >
                </li>
                <li
                  v-if="
                    invoice.accept_payment === 1 &&
                    (invoice.currency === 'NGN' || invoice.currency === 'USD')
                  "
                >
                  <div class="btn-group">
                    <button
                      type="button"
                      class="btn btn-primary dropdown-toggle me-1"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Action
                    </button>
                    <div class="dropdown-menu">
                      <a
                        class="dropdown-item"
                        @click="openPaymentModal(invoice)"
                        ><i class="fa fa-credit-card me-2"></i>Make secure
                        payment</a
                      >
                      <div v-if="invoice.accept_payment === 1">
                        <a
                          v-if="
                            invoice.currency === 'NGN' &&
                            (invoice.active_payment_keys.paystack === true ||
                              invoice.active_payment_keys.paystack === 1)
                          "
                          class="dropdown-item"
                          @click="openCustomerPaymentModal(invoice, 'paystack')"
                          ><i class="fa fa-credit-card me-2"></i>Pay via
                          Paystack</a
                        >
                        <a
                          v-if="
                            invoice.currency !== 'NGN' &&
                            (invoice.active_payment_keys.stripe === true ||
                              invoice.active_payment_keys.stripe === 1)
                          "
                          class="dropdown-item"
                          @click="openCustomerPaymentModal(invoice, 'stripe')"
                          ><i class="fa fa-credit-card me-2"></i>Pay via
                          Stripe</a
                        >
                        <a
                          v-if="
                            invoice.currency !== 'NGN' &&
                            (invoice.active_payment_keys.paypal === true ||
                              invoice.active_payment_keys.paypal === 1)
                          "
                          class="dropdown-item"
                          @click="openCustomerPaymentModal(invoice, 'paypal')"
                          ><i class="fa fa-credit-card me-2"></i>Pay via
                          Paypal</a
                        >
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /Page Header -->
        <div class="row justify-content-center" v-if="invoice">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="card-table">
                  <!-- For mobile -->
                  <mobileinvoiceview
                    :invoice="invoice"
                    :totalProductDiscount="totalProductDiscount"
                    :taxableAmount="taxableAmount"
                    :totalAmount="totalAmount"
                    :preferred_bank="preferred_bank"
                    :vat="vat"
                    :tax_percentage="tax_percentage"
                  />

                  <!-- For Desktop -->
                  <div class="card-body d-invoice" id="invoice">
                    <!-- Invoice Logo -->
                    <div class="invoice-item invoice-item-one">
                      <div class="invoice-header">
                        <div class="col-md-4 col-lg-4">
                          <div class="invoice-logo">
                            <img
                              :src="invoice?.user?.setting?.business_logo"
                              alt="logo"
                            />
                          </div>
                        </div>
                        <div class="descrip col-md-6 col-lg-4">
                          <div class="invoice-info">
                            <h1 class="invoice-head mb-2">
                              {{ invoice?.invoice_id }}
                            </h1>
                            <p class="total-inner-p text-end me-2">
                              {{ invoice?.description }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Invoice Logo -->

                    <!-- Invoice To -->
                    <div class="invoice-item invoice-item-two">
                      <div class="invoice-address">
                        <div class="invoice-to">
                          <p class="customer-text-one">Invoice From:</p>
                          <p class="invoice-details-two">
                            {{ invoice?.user?.name }}
                          </p>
                          <p class="invoice-details-two">
                            {{ invoice?.user?.email }}
                          </p>
                          <p class="invoice-details-two">
                            {{ invoice?.user?.phone }}
                          </p>
                          <p class="invoice-details-two">
                            {{ invoice?.user?.address }}
                          </p>
                          <p class="invoice-details-two">
                            {{ invoice?.user?.state }}
                            {{ invoice?.user?.country }}
                          </p>
                        </div>
                        <div>
                          <p class="customer-text-one">Invoice To:</p>
                          <p class="invoice-details-two">
                            {{ invoice?.customer?.name }}<br />
                            {{ invoice?.customer?.email }}<br />
                            {{
                              `${invoice?.customer?.country_code} ${invoice?.customer?.phone}`
                            }}<br />
                            {{ invoice?.customer?.address }}<br />
                            {{ invoice?.customer?.state }}
                            {{ invoice?.customer?.country }}
                          </p>
                        </div>
                        <div class="invoice-to">
                          <p class="invoice-details-two text-end">
                            Status<br />
                            <span
                              class="invoice-status text-success"
                              v-if="
                                invoice.status === 'paid' ||
                                invoice.status === 'sent' ||
                                invoice.status === 'viewed' ||
                                invoice.status === 'accepted'
                              "
                              >{{ invoice.status }}</span
                            >
                            <span
                              class="invoice-status text-warning"
                              v-else-if="
                                invoice.status === 'draft' ||
                                invoice.status === 'pending' ||
                                invoice.status === 'unpaid' ||
                                invoice.status === 'recurring'
                              "
                              >{{ invoice.status }}</span
                            >
                            <span
                              class="invoice-status text-warning"
                              v-else-if="invoice.status === 'partially_paid'"
                              >Partially paid</span
                            >
                            <span
                              class="invoice-status text-danger"
                              v-else-if="
                                invoice.status === 'expired' ||
                                invoice.status === 'rejected' ||
                                invoice.status === 'refunded' ||
                                invoice.status === 'overdue'
                              "
                              >{{ invoice.status }}</span
                            >
                          </p>
                          <p class="invoice-details-two text-end">
                            Date<br /><strong v-if="invoice.date">{{
                              formatDateToDigits(invoice?.date)
                            }}</strong>
                          </p>
                          <p class="invoice-details-two text-end">
                            Due on<br /><strong v-if="invoice.due_date">{{
                              formatDateToDigits(invoice?.due_date)
                            }}</strong>
                          </p>
                          <p class="invoice-details-two text-end">
                            Amount<br /><strong
                              >{{ invoice?.currency?.slice(0, 3) }}
                              {{
                                addCurrencyComma(invoice?.total_amount)
                              }}</strong
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- /Invoice To -->

                    <!-- Invoice Item -->
                    <div class="invoice-item invoice-table-wrap">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-responsive2">
                            <table class="table table-center table-hover mb-0">
                              <thead class="thead-light">
                                <tr>
                                  <th class="table-data">#</th>
                                  <th class="table-data">Product / Service</th>
                                  <th class="table-data">Quantity</th>
                                  <th class="table-data">Price</th>
                                  <th class="table-data">Discount</th>
                                  <th class="text-end table-data">Amount</th>
                                </tr>
                              </thead>
                              <tbody v-if="invoice.items">
                                <tr
                                  v-for="(item, index) in invoice.items"
                                  :key="index"
                                >
                                  <td class="table-data">
                                    {{ index + 1 }}
                                  </td>
                                  <td class="table-data">{{ item.name }}</td>
                                  <td class="table-data">
                                    {{ item.quantity }}
                                  </td>
                                  <td class="table-data">
                                    {{ invoice?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(item.price) }}
                                  </td>
                                  <td class="table-data">
                                    {{ item.discount }}%
                                  </td>
                                  <td class="text-end table-data">
                                    {{ invoice?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(item.amount) }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Invoice Item -->

                    <!-- Terms & Conditions -->
                    <div class="terms-conditions border-0">
                      <div class="row justify-content-end">
                        <div style="width: 48.5%; padding-right: 25px">
                          <div class="invoice-total-card">
                            <div class="invoice-total-box">
                              <div class="invoice-total-inner">
                                <p class="total-inner-p">
                                  Taxable Amount
                                  <span
                                    >{{ invoice?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(invoice.amount) }}</span
                                  >
                                </p>
                                <p class="total-inner-p">
                                  Discount<span
                                    >{{ invoice?.currency?.slice(0, 3) }}
                                    {{
                                      addCurrencyComma(totalProductDiscount)
                                    }}</span
                                  >
                                </p>
                                <p
                                  class="total-inner-p"
                                  v-if="invoice?.tax_enabled === 1"
                                >
                                  {{ `VAT(${invoice.tax_percentage}%)` }}
                                  <span
                                    >{{ invoice?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(vat) }}</span
                                  >
                                </p>
                                <p
                                  class="total-inner-p"
                                  v-for="(
                                    discount, index
                                  ) in invoice?.more_discount"
                                  :key="index"
                                >
                                  {{ discount?.description }}
                                  <span
                                    >- {{ invoice?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(discount.value) }}</span
                                  >
                                </p>
                                <p
                                  class="total-inner-p"
                                  v-for="(
                                    charge, index
                                  ) in invoice?.additional_charges"
                                  :key="index"
                                >
                                  {{ charge.description }}
                                  <span
                                    >+ {{ invoice?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(charge.value) }}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Total -->
                    <div class="terms-conditions">
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <div style="width: 54%">
                          <div>
                            <p class="total-inner-p">
                              Total Items :
                              {{ invoice?.items?.length }}
                            </p>
                          </div>
                        </div>
                        <div style="width: 47.8%; padding-right: 10px">
                          <div class="invoice-total-card">
                            <div class="invoice-total-box">
                              <div class="invoice-total-footer">
                                <h4
                                  class="total-amount"
                                  style="font-size: 20px"
                                >
                                  Total Amount
                                  <span
                                    >{{ invoice?.currency?.slice(0, 3) }}
                                    {{
                                      addCurrencyComma(invoice?.total_amount)
                                    }}</span
                                  >
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Total -->
                    <div
                      v-if="invoice?.amount_paid != 0"
                      class="terms-conditions pt-4"
                    >
                      <div style="display: flex; justify-content: flex-end">
                        <div style="width: 46.5%; padding-right: 10px">
                          <div class="invoice-total-card">
                            <div class="invoice-total-box">
                              <div class="invoice-total-footer">
                                <h4
                                  class="total-amount2"
                                  style="font-size: 15px"
                                >
                                  Amount paid
                                  <span
                                    >{{ invoice?.currency?.slice(0, 3) }}
                                    {{
                                      addCurrencyComma(invoice?.amount_paid)
                                    }}</span
                                  >
                                </h4>
                                <h4
                                  class="total-amount2 mt-3"
                                  style="font-size: 15px"
                                >
                                  Balance
                                  <span
                                    >{{ invoice?.currency?.slice(0, 3) }}
                                    {{
                                      addCurrencyComma(invoice?.amount_due)
                                    }}</span
                                  >
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Total -->
                    <div class="terms-conditions">
                      <div style="display: flex; justify-content: start">
                        <div>
                          <div class="py-2">
                            <p class="total-inner-p">
                              Total Amount (in words):
                              <span
                                style="
                                  margin-left: 2px;
                                  color: black;
                                  text-transform: capitalize;
                                "
                                v-if="invoice?.total_amount"
                              >
                                {{
                                  amountToWords(
                                    invoice?.total_amount,
                                    invoice?.currency
                                  )
                                }}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Bank Details and Signature-->
                    <div class="terms-conditions">
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <div>
                          <div v-if="invoice?.user?.setting?.preferred_bank_id">
                            <h1 class="bank-title total-amount">
                              Bank Information
                            </h1>
                            <p class="total-inner-p">
                              Bank's Name:
                              <span class="text-black">{{
                                invoice.preferred_bank?.bank_name
                              }}</span>
                            </p>
                            <p class="total-inner-p">
                              Account Number:
                              <span
                                @click="copyAccount"
                                class="btn-filters w-auto  px-2"
                              >
                                {{ invoice.preferred_bank?.account_number
                                }}<i
                                  class="fa fa-clone me-2  px-2"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </p>
                            <p class="total-inner-p">
                              Account Name:
                              <span class="text-black">{{
                                invoice.preferred_bank?.account_name
                              }}</span>
                            </p>
                          </div>
                        </div>
                        <div class="text-end" v-if="invoice.signature != null">
                          <p
                            class="total-inner-p"
                            style="color: black; margin-bottom: 8px"
                          >
                            {{ invoice?.signatory_name }}
                          </p>
                          <img
                            style="max-width: 150px"
                            :src="invoice?.signature"
                            alt="Signature"
                          />
                        </div>
                        <div
                          class="text-end"
                          v-if="
                            invoice.signature == null &&
                            invoice?.user?.setting.signature != null
                          "
                        >
                          <p
                            class="total-inner-p"
                            style="color: black; margin-bottom: 8px"
                          >
                            {{ invoice?.user?.setting?.signatory_name }}
                          </p>
                          <img
                            style="max-width: 150px"
                            :src="invoice?.user?.setting?.signature"
                            alt="Signature"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Terms and Conditions -->
                    <div v-if="invoice?.terms" class="terms-conditions">
                      <div style="display: flex">
                        <div class="text-start">
                          <p class="bank-title total-amount">
                            Terms and Conditions
                          </p>
                          <div
                            class="total-inner-e"
                            v-html="invoice?.terms"
                          ></div>
                        </div>
                      </div>
                    </div>

                    <!-- Note -->
                    <div class="terms-conditions">
                      <div>
                        <div>
                          <div class="text-start">
                            <p class="bank-title total-amount">Notes</p>
                            <div
                              class="total-inner-e"
                              v-html="invoice.notes"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

            
                </div>
              </div>
            </div>
          </div>
        </div>
        <div  v-if="showPayment">
                  <RecordedPayments :payments="invoice?.payments"/>
                </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>

  <!-- Delete Expense Modal -->
  <div class="modal custom-fade fade" id="delete_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>
              <span v-if="selectedAction === 'download'">Download Invoice</span>
            </h3>
            <p v-if="selectedItem">
              Are you sure want to
              <span v-if="selectedAction === 'download'">download</span>
              <span class="fw-semibold ms-1">{{
                selectedItem.customer.name
              }}</span>
              Invoice?
            </p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row d-flex flex-column align-items-center">
              <div class="col-6 mb-2">
                <button
                  v-if="selectedAction === 'download'"
                  @click="downloadInvoice()"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Download</span>
                  <span v-if="isLoading">Downloading...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete Expense Modal -->
  <!-- Payment Modal -->
  <div class="modal custom-fade fade" id="payment_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <form @submit.prevent="makePayment" class="modal-body">
          <div class="form-header">
            <h3>Make Payment</h3>
            <div
              class="form-group text-start mt-2"
              v-if="invoice?.currency === 'USD'"
            >
              <label for="currencyLabel">Gateway</label>

              <b-form-select
                class="form-select"
                v-model="payment_form.gateway"
                required
              >
                <b-form-select-option selected value=""
                  >Please select</b-form-select-option
                >
                <b-form-select-option
                  v-for="(gateway, index) in allGateway"
                  :key="index"
                  :value="gateway.value"
                >
                  {{ gateway.name }}
                </b-form-select-option>
              </b-form-select>
            </div>
            <div class="form-group text-start mt-2">
              <label>Amount</label>
              <b-input-group>
                <b-input-group-prepend is-text>
                  <span style="font-size: 12px">{{ invoice?.currency }}</span>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  v-model="payment_form.amount"
                  :max="invoice.amount_due"
                  min="1"
                  class="form-control"
                  placeholder="Enter the Amount"
                  required
                />
              </b-input-group>
            </div>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <button
                  type="submit"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Make Payment</span>
                  <span v-if="isLoading">Processing...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  type="submit"
                  @click="closePaymentModal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- Payment Modal -->
  <!--Customer Payment Modal -->
  <div class="modal custom-fade fade" id="customer_payment_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <form @submit.prevent="makeCustomerPayment" class="modal-body">
          <div class="form-header">
            <h3>Make Payment</h3>
            <div class="form-group text-start mt-2">
              <label>Amount</label>
              <b-input-group>
                <b-input-group-prepend is-text>
                  <span style="font-size: 12px">{{ invoice?.currency }}</span>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  v-model="customer_payment_form.amount"
                  :max="invoice.amount_due"
                  min="1"
                  class="form-control"
                  placeholder="Enter the Amount"
                  required
                />
              </b-input-group>
            </div>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <button
                  type="submit"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Make Payment</span>
                  <span v-if="isLoading">Processing...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  type="submit"
                  @click="closeCustomerPaymentModal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!--Customer Payment Modal -->
  <!-- /Main Wrapper -->
</template>

<script setup>
import { computed, onMounted, ref, watchEffect } from "vue";
import html2pdf from "html2pdf.js";
import { useStore } from "vuex";
  import { useHead} from '@vueuse/head'
import { onBeforeRouteLeave, useRoute, useRouter } from "vue-router";
import { addCurrencyComma, amountToWords } from "@/assets/composables/currency";
import { formatDateToDigits } from "@/assets/composables/date";
import { Modal } from "bootstrap";
import { createToaster } from "@meforma/vue-toaster";
import RecordedPayments from "../../../components/recorded-payments.vue";
const toast = createToaster({ position: "top-right", duration: 3000 });
const store = useStore();
const route = useRoute();
const router = useRouter();
const selectedItem = ref(null);
const selectedAction = ref(null);
const modalInstance = ref(null);
const paymentModal = ref(null);
const customerPaymentModal = ref(null);
const isLoading = ref(false);
const taxableAmount = ref(0);
const totalCharges = ref(0);
const totalDiscount = ref(0);
const totalAmount = ref(0);
const tax_percentage = ref(0);
const vat = ref(0);
const totalProductDiscount = ref(0);
const showPayment = ref(false)

const allGateway = [
  { name: "Stripe", value: "stripe" },
  { name: "Paypal", value: "paypal" },
];

const payment_form = ref({
  invoice_id: "",
  amount: "",
  wallet: true,
  gateway: "",
});

const customer_payment_form = ref({
  invoice_id: "",
  amount: "",
  wallet: true,
  gateway: "",
});

const openModal = (invoice, name) => {
  isLoading.value = false;
  selectedAction.value = name;
  selectedItem.value = invoice;
  modalInstance.value.show();
};
const closeModal = () => {
  modalInstance.value.hide();
};

const openPaymentModal = (invoice) => {
  isLoading.value = false;
  payment_form.value.invoice_id = invoice.id;
  payment_form.value.amount = invoice.amount_due;
  paymentModal.value.show();
};
const closePaymentModal = () => {
  paymentModal.value.hide();
  payment_form.value = {
    invoice_id: "",
    amount: null,
    wallet: true,
  };
};

const openCustomerPaymentModal = (invoice, gateway) => {
  isLoading.value = false;
  customer_payment_form.value.invoice_id = invoice.id;
  customer_payment_form.value.amount = invoice.amount_due;
  customer_payment_form.value.gateway = gateway;
  customerPaymentModal.value.show();
};

const closeCustomerPaymentModal = () => {
  customerPaymentModal.value.hide();
  customer_payment_form.value = {
    invoice_id: "",
    amount: null,
    wallet: true,
    gateway: "",
  };
};

const paymentlink = computed(() => {
  return store.getters["invoices/paystacklink"];
});

const makePayment = async () => {
  isLoading.value = true;
  if (invoice.value.currency === "NGN") {
    payment_form.value.gateway = "paystack";
  }
  await store
    .dispatch("invoices/makePayment", payment_form.value)
    .then(() => {
      isLoading.value = false;
      closePaymentModal();
    })
    .then(() => {
      if (paymentlink.value !== null) {
        window.location.href = paymentlink.value;
      }
    })
    .catch(() => {
      isLoading.value = false;
      closePaymentModal();
    });
};

const makeCustomerPayment = async () => {
  isLoading.value = true;
  await store
    .dispatch("invoices/makePayment", customer_payment_form.value)
    .then(() => {
      isLoading.value = false;
      closeCustomerPaymentModal();
    })
    .then(() => {
      if (paymentlink.value !== null) {
        window.location.href = paymentlink.value;
      }
    })
    .catch(() => {
      isLoading.value = false;
      closeCustomerPaymentModal();
    });
};

const calculateCharges = () => {
  let totalcharges = 0;
  totalCharges.value = 0;
  for (let i = 0; i < invoice.value?.additional_charges?.length; i++) {
    const item = invoice.value.additional_charges[i];
    totalcharges += parseInt(item.value);
  }
  totalCharges.value = totalcharges;
};
const calculateDiscount = () => {
  let totaldiscount = 0;
  totalDiscount.value = 0;
  for (let i = 0; i < invoice.value?.more_discount?.length; i++) {
    const item = invoice.value.more_discount[i];
    totaldiscount += parseInt(item.value);
  }
  totalDiscount.value = totaldiscount;
};
const calculateTotalAmount = () => {
  // Calculate Total amount
  let totalproductamount = 0;
  let totalproductdiscount = 0;
  let totalamount = 0;
  for (let i = 0; i < invoice.value?.items?.length; i++) {
    const item = invoice.value.items[i];
    totalproductamount += item.amount;
    totalproductdiscount += (item.discount / 100) * item.amount;
  }
  taxableAmount.value = totalproductamount;
  totalProductDiscount.value = totalproductdiscount;
  calculateCharges();
  calculateDiscount();
  let T1 = totalproductamount + totalCharges.value;
  let T2 = totalproductdiscount + totalDiscount.value;
  totalamount = T1 - T2;
  // Calculate Tax
  if (invoice.value.tax_enabled === 1) {
    vat.value = (tax_percentage.value * totalamount) / 100;
    totalAmount.value = totalamount + vat.value;
  } else {
    totalAmount.value = totalamount;
  }
};

const invoice = computed(() => {
  return store.getters["invoices/customer_invoice"];
});

watchEffect(() => {
  if (!invoice.value) return

  const businessName = invoice.value.user?.name || 'Soft Invoice'
  const description = invoice.value.description || 'Streamline your invoicing process with Soft Invoice — create branded invoices, track payments, and manage clients with ease.'
  const logo = invoice.value.user?.setting?.business_logo || ''
  const pageUrl = window.location.href

  useHead({
    title: businessName,
    meta: [
      { name: 'description', content: description },
      { property: 'og:title', content: businessName },
      { property: 'og:description', content: description },
      { property: 'og:image', content: logo },
      { property: 'og:url', content: pageUrl },
      { property: 'og:type', content: 'website' },
    ],
  })
})

let prev_page = localStorage.getItem("prev_page");

const getCustomerInvoice = async () => {
  let data = null;
  if (prev_page === "invoice-details") {
    data = {
      code: route.params.id,
      notify: false,
    };
  } else {
    data = {
      code: route.params.id,
      notify: true,
    };
  }
  await store
    .dispatch("invoices/getCustomerInvoice", data)
    .then(() => {
      tax_percentage.value = invoice.value?.tax_percentage;
    })
    .then(() => {
      calculateTotalAmount();
    });
};

const downloadInvoice = async () => {
  isLoading.value = true;
  let screenwidth = window.screen.width;
  const element = document.getElementById("invoice");
  if (screenwidth <= 960) {
    element.style.display = "block";
  }
  const options = {
    filename: `${invoice.value.invoice_id}.pdf`,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: {
      dpi: 192,
      letterRendering: true,
      allowTaint: true,
      useCORS: true,
      logging: true,
    },
    jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
  };
  const invoicedetailstwo = document.getElementsByClassName(
    "invoice-details-two"
  );
  const customertextone = document.getElementsByClassName("customer-text-one");
  const totalinnerp = document.getElementsByClassName("total-inner-p");
  const mobiledes = document.getElementsByClassName("descrip");
  const totalinnere = document.getElementsByClassName("total-inner-e");
  const totalamount = document.getElementsByClassName("total-amount");
  const totalamount2 = document.getElementsByClassName("total-amount2");
  const tabledata = document.getElementsByClassName("table-data");
  const invoicehead = document.getElementsByClassName("invoice-head");
  for (let i = 0; i < invoicedetailstwo.length; i++) {
    invoicedetailstwo[i].style.fontSize = "12px";
  }
  for (let i = 0; i < customertextone.length; i++) {
    customertextone[i].style.fontSize = "12px";
  }
  for (let i = 0; i < totalinnerp.length; i++) {
    totalinnerp[i].style.fontSize = "12px";
  }
  for (let i = 0; i < mobiledes.length; i++) {
    mobiledes[i].style.width = "col-4";
  }
  for (let i = 0; i < totalamount.length; i++) {
    totalamount[i].style.fontSize = "14px";
  }
  for (let i = 0; i < totalamount2.length; i++) {
    totalamount2[i].style.fontSize = "14px";
  }
  for (let i = 0; i < tabledata.length; i++) {
    tabledata[i].style.fontSize = "12px";
  }
  for (let i = 0; i < invoicehead.length; i++) {
    invoicehead[i].style.fontSize = "22px";
  }
  for (let i = 0; i < totalinnere.length; i++) {
    totalinnere[i].fontSize = "12px";
  }
  await html2pdf()
    .set(options)
    .from(element)
    .save()
    .then(() => {
      for (let i = 0; i < invoicedetailstwo.length; i++) {
        invoicedetailstwo[i].style.fontSize = "14px";
      }
      for (let i = 0; i < customertextone.length; i++) {
        customertextone[i].style.fontSize = "14px";
      }
      for (let i = 0; i < totalinnerp.length; i++) {
        totalinnerp[i].style.fontSize = "14px";
      }
      for (let i = 0; i < totalamount.length; i++) {
        totalamount[i].style.fontSize = "20px";
      }
      for (let i = 0; i < totalamount2.length; i++) {
        totalamount2[i].style.fontSize = "15px";
      }
      for (let i = 0; i < tabledata.length; i++) {
        tabledata[i].style.fontSize = "14px";
      }
      for (let i = 0; i < invoicehead.length; i++) {
        invoicehead[i].style.fontSize = "26px";
      }
      for (let i = 0; i < totalinnere.length; i++) {
        totalinnere[i].fontSize = "14px";
      }
      if (screenwidth <= 960) {
        element.style.display = "none";
      }
      closeModal();
      isLoading.value = false;
    });
};

// Copy invoice link
const link = window.location.href;
const copyInvoiceLink = () => {
  if (!navigator.clipboard) {
    toast.error("Clipboard API is not supported in this browser.");
    return;
  }

  navigator.clipboard
    .writeText(link)
    .then(() => {
      toast.success("Link copied to clipboard");
    })
    .catch((error) => {
      toast.error("Failed to copy link to clipboard");
    });
};




const copyAccount = () => {
  const account_number = invoice.value.preferred_bank?.account_number
  if (!navigator.clipboard) {
    toast.error("Clipboard API is not supported in this browser.");
    return;
  }

  navigator.clipboard
    .writeText(account_number)
    .then(() => {
      toast.success("Account number copied Successfully");
    })
    .catch((error) => {
      toast.error("Failed to copy Account number to clipboard");
    });
};

const settings = computed(() => {
	return store.getters["settings/settings"];
});
const getSettings = () => {
	store.dispatch("settings/getSettings").then(() => {
    showPayment.value = settings.value.payment_history_on_invoice_page
  });;
};



onMounted(() => {
  getSettings()
  getCustomerInvoice();



  modalInstance.value = new Modal(document.getElementById("delete_modal"), {
    backdrop: "static",
    keyboard: false,
  });
  paymentModal.value = new Modal(document.getElementById("payment_modal"), {
    backdrop: "static",
    keyboard: false,
  });
  customerPaymentModal.value = new Modal(
    document.getElementById("customer_payment_modal"),
    {
      backdrop: "static",
      keyboard: false,
    }
  );
});

onBeforeRouteLeave((to, from, next) => {
  localStorage.removeItem("prev_page");
  next();
});
</script>

<style>
.customer-view-wrapper {
  width: 75%;
  padding: 50px;
  position: relative;
  margin: 0 auto;
  box-sizing: border-box;
}
@media (max-width: 960px) {
  .customer-view-wrapper {
    width: 100%;
    padding: 50px 0 0 0;
    margin: 0 auto;
  }
}
</style>
